export default "__VITE_ASSET__CLpP87UO__"